import EmptyAssetCard from "../../../../common/features/asset/EmptyAssetCard";
import NthEdition from "../../../../common/features/asset/NthEdition";
import styles from "./TitleResultCard.module.scss";
import AssetTopRow from "../../../../common/features/asset/AssetTopRow";
import TruncatedTitle from "../../../../common/features/asset/TruncatedTitle";
import { ManageAssetWithLicense } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import useStandardAssetPopover from "../../common/asset-popover/useStandardAssetPopover.tsx";

interface TitleResultCardProps {
  asset: ManageAssetWithLicense;
  lazyLoad?: boolean;
  className?: string;
}

export default function TitleResultCard({
  asset,
  lazyLoad,
  className,
}: TitleResultCardProps) {
  const { popoverLinks, renderPopoverLinkDependencies } =
    useStandardAssetPopover(asset);

  const primaryAction = popoverLinks[0];

  return (
    <li className={className}>
      <EmptyAssetCard
        vbid={asset.manageAsset.vbid}
        type="auto"
        tagName="div"
        lazyLoad={lazyLoad}
        primaryAction={primaryAction}
      >
        <AssetTopRow
          asset={asset.manageAsset}
          license={asset.license}
          links={popoverLinks}
        />
        <div className={styles.bookDetails}>
          <BaseLinkOrButton
            href={primaryAction.href}
            to={primaryAction.to}
            onClick={primaryAction.onClick}
            className={styles.title}
          >
            <TruncatedTitle asset={asset.manageAsset} tagName="h3" />
          </BaseLinkOrButton>
          <NthEdition asset={asset.manageAsset} className={styles.edition} />
          <div className={styles.author}>{asset.manageAsset.author}</div>
        </div>
      </EmptyAssetCard>
      {renderPopoverLinkDependencies()}
    </li>
  );
}
